<template>
    <Dropdown class="RPNotifications">
        <template v-slot="{toggleDropdown}">
            <button
                class="RPNotifications__button"
                @click="toggleDropdown"
            >
                <StreamlineIcon
                    class="RPNotifications__button-icon"
                    :icon="icon.icon"
                    :stroke="icon.stroke"
                    :size="20"
                />
            </button>
        </template>
        <template v-slot:dropdown="{isModal, close}">
            <NotificationsDropdown
                :reports="reports"
                :notifications="notifications"
                :is-modal="isModal"
                @report="r => emit('report', r, close)"
                @notification="n => emit('notification', n, close)"
                @download="d => emit('download', d, close)"
                @notification-page="emit('notification-page', '', close)"
                @delete-notification="id => emit('delete-notification', id, close)"
            />
        </template>
    </Dropdown>
</template>
<script>
import {
    AlarmBell,
    AlarmBellTimer,
    AlarmBellCheck
} from '@reviewpush/streamline-regular/lib/interface-essential/Alert';
import StreamlineIcon from "@reviewpush/streamline-icons-vue";
import {textGrey, primary, success} from 'style/_colors.scss';
import stat from 'status';
import NotificationsDropdown from './NotificationsDropdown.vue';
import Dropdown from '@/components/Basic/Elements/Dropdown.vue';

export default {
    name: 'RPNotifications',
    components: {
        StreamlineIcon,
        NotificationsDropdown,
        Dropdown
    },
    props: {
        reports: {
            type: Array,
            default: () => ([])
        },
        notifications: {
            type: Array,
            default: () => ([])
        }
    },
    computed: {
        icon() {
            if(this.reports.findIndex(r => r.status === stat.GENERATING) !== -1){
                return {icon: AlarmBellTimer, stroke: primary};
            }
            if(this.reports.findIndex(r => r.status === stat.SUCCESS) !== -1){
                return {icon: AlarmBellCheck, stroke: success};
            }
            if(this.notifications.filter(n => !n.created_at).length) {
                return {icon: AlarmBell, stroke: primary};
            }
            return {icon: AlarmBell, stroke: textGrey};
        }
    },
    methods: {
        emit(action, payload, closeDropdown){
            this.$emit(action, payload);
            this.$emit('mark-read');
            closeDropdown();
        }
    }
};
</script>
<style lang="scss">
    .RPNotifications {
        vertical-align: top;
        margin-right: 1rem;
        display: inline-block;
        height: 100%;
        &__button{
            height: 100%;
            &-icon{
                vertical-align: middle;
            }
        }
    }
</style>
